import isEmpty from '../utils/isEmpty'

// todo: deprecated
export function dictTranslation__ (value, dict) {
  if (isEmpty(dict)) {
    return ''
  } else {
    let result = dict.filter(v => v.dataValue === value)
    if (result.length > 0) {
      return result[0].dataName
    } else {
      return ''
    }
  }
}

export function id2name__ (value, arr, key = 'dataValue/dataName') {
  if (isEmpty(arr)) {
    return ''
  } else {
    const [id, name] = key.split('/')
    let result = arr.filter(v => v[id] === value)
    if (result.length > 0) {
      return result[0][name]
    } else {
      return ''
    }
  }
}

export function whether__ (value, thereBe) {
  switch (Number(value)) {
    case 0:
      return thereBe ? '无' : '否'
    case 1:
      return thereBe ? '有' : '是'
    default:
      return ''
  }
}

export function whetherType__ (value) {
  return isEmpty(value) ?
    '' :
    ['info', 'warning'][value]
}

export function dialogTitle__ (value, catalog) {
  return isEmpty(value) ? '' : {
    c: '新增',
    r: '查看',
    u: '编辑',
    ...catalog,
  }[value]
}

export function status__ (value, reverse) {
  return isEmpty(value) ?
    '' :
    reverse ?
      ['启用', '停用'][value] :
      ['停用', '启用'][value]
}

export function statusType__ (value) {
  return isEmpty(value) ?
    '' :
    ['warning', 'success'][value]
}
